module.exports = __webpack_public_path__ + "img/LOGOUT.f05c8499.svg";